export const ONBOARDING_STATUS = {
  PENDING: "pending",
  COMPLETED: "completed",
} as const;

export const ONBOARDING_PREFERENCES_KEY = "onboarding_status";

export type OnboardingStatus =
  typeof ONBOARDING_STATUS[keyof typeof ONBOARDING_STATUS];

export const ONBOARDING_DELAY: number = 421;

export const ONBOARDING_MINIMUM_SCREEN_HEIGHT: number = 721;
